import { sourcesData } from '@/mocks/catalogData';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-10 md:py-14">
        {/* Top section */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-8">
          {/* Logo & tagline */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
              <i className="ri-scales-3-line text-white text-sm" />
            </div>
            <span className="font-heading text-lg md:text-xl font-semibold tracking-tight">
              ПРАВО
            </span>
          </div>

          {/* Sources */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
            <span className="text-xs md:text-sm text-background-400 uppercase tracking-wider font-medium">
              Источники
            </span>
            <div className="flex flex-wrap gap-3">
              {sourcesData.map((source) => (
                <a
                  key={source.name}
                  href={source.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors flex items-center gap-1"
                >
                  {source.name}
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-external-link-line text-xs" />
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="my-6 md:my-8 border-t border-background-700/40" />

        {/* Bottom section */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs text-background-400">
            Портал законодательства РФ. Данные обновляются ежедневно.
          </p>
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} pravo.starec.ai
          </p>
        </div>
      </div>
    </footer>
  );
}